//dependencies
import React from "react";
import { z } from "zod";

//components
import { FormRadioButtons, PanelFilters } from "@performyard/py-components";

const ReviewsOfMeFilterSchema = z.object({
	status: z.string().optional(),
	easyAddStatus: z.string().optional(),
});

export type ReviewsOfMeFilters = z.infer<typeof ReviewsOfMeFilterSchema>;

export const ReviewsOfMe360ReviewsOptions = [
	{ value: "easyAddEnabled", label: "360 Enabled" },
	{ value: "awaitingApproval", label: "Awaiting Approval" },
];

export const ReviewsOfMeStatusOptions = [
	{ value: "active", label: "Active" },
	{ value: "complete", label: "Completed" },
	{ value: "scheduled", label: "Scheduled" },
];

interface ReviewsOfMeFiltersPanelProps {
	filters?: ReviewsOfMeFilters;
	isOpen: boolean;
	onClose: () => void;
	onApplyFilters: (filters: ReviewsOfMeFilters) => void;
}

export const ReviewsOfMeFiltersPanel = ({ filters, isOpen, onClose, onApplyFilters }: ReviewsOfMeFiltersPanelProps) => {
	const handleSubmit = ({
		value,
	}: {
		value: ReviewsOfMeFilters;
		resetForm: () => void;
		setError: (field: keyof ReviewsOfMeFilters, error: string) => void;
	}) => {
		const formattedState = { ...value };

		// Remove empty, null, or undefined fields
		Object.keys(formattedState).forEach((key) => {
			const filterValue = formattedState[key];
			if (filterValue === null || filterValue === undefined || filterValue === "") {
				delete formattedState[key];
			}
		});

		onApplyFilters(formattedState);
		onClose();
	};

	const defaultValues: ReviewsOfMeFilters = {
		status: filters?.status,
		easyAddStatus: filters?.easyAddStatus,
	};

	return (
		<PanelFilters
			isOpen={isOpen}
			onClose={onClose}
			schema={ReviewsOfMeFilterSchema}
			defaultValues={defaultValues}
			onSubmit={handleSubmit}
		>
			<div className="space-y-4">
				<FormRadioButtons id="status" label="Status" options={ReviewsOfMeStatusOptions} />

				<FormRadioButtons id="easyAddStatus" label="360 Reviews" options={ReviewsOfMe360ReviewsOptions} />
			</div>
		</PanelFilters>
	);
};

export default ReviewsOfMeFiltersPanel;
